import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLoggedGuard, SessionExpiredGuard } from '../../core/guards';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
    canActivate: [AuthLoggedGuard],
    data: { title: 'ROUTES.LOGIN' },
  },
  {
    path: 'recovery',
    loadChildren: () => import('./reset-password/reset-password.module').then(m => m.ResetPasswordModule),
    data: { title: 'ROUTES.FORGOT PASSWORD' },
  },
  {
    path: 'forgot-password/:token',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
    data: { title: 'ROUTES.RECOVER PASSWORD' },
  },
  {
    path: 'confirm-account/:status',
    loadChildren: () => import('./confirm-account/confirm-account.module').then(m => m.ConfirmAccountModule),
    data: { title: 'ROUTES.CONFIRM ACCOUNT' },
  },
  {
    path: 'active-account',
    loadChildren: () => import('./activate-account/activate-account.module').then(m => m.ActivateAccountModule),
    data: { title: 'ROUTES.ACTIVATE ACCOUNT' },
  },
  {
    path: 'register',
    loadComponent: () => import('./register/register.component').then(m => m.RegisterComponent),
    data: { title: 'ROUTES.SIGN UP' },
    children: [
      {
        path: 'create-account',
        loadComponent: () =>
          import('./register/forms/create-account/create-account.component').then(m => m.CreateAccountComponent),
        data: { title: 'ROUTES.SIGN UP' },
      },
      {
        path: 'account-info',
        canActivate: [SessionExpiredGuard],
        loadComponent: () =>
          import('./register/forms/account-info/account-info.component').then(m => m.AccountInfoComponent),
        data: { title: 'ROUTES.ACCOUNT INFO' },
      },
      {
        path: 'verify-code',
        loadComponent: () =>
          import('./register/forms/verify-code/verify-code.component').then(m => m.VerifyCodeComponent),
        data: { title: 'ROUTES.VERIFY CODE' },
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'create-account',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
